export default __webpack_public_path__ + "static/media/active-wear.08c7d4e6.JPG";